export enum ImageRatio {
    Horizontal2By1 = "2:1",
    Horizontal16By9 = "16:9",
    Horizontal4By3 = "4:3",
    Square1By1 = "1:1",
    Circle1By1 = "1:1-circle",
    Vertical3By4 = "3:4",
    Original = "original",
}
